import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2025 AnyGRC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;